export const indexUsersPath: string = "/users";
// export const showInsideSalesPath: string = "/insideSales/:id";
// export const showInsideSalesPathCreator = (id: number|string): string => `/insideSales/${id}`
// export const editInsideSalesPath: string = "/insideSales/:id/edit"
// export const editInsideSalesPathCreator = (id: number|string): string => `/insideSales/${id}/edit`
